import { TableRow, TableCell, IconButton, Tooltip, Box } from '@mui/material'
import { DeleteOutline } from '@mui/icons-material'
import { useDispatch, useSelector } from 'react-redux'
import { updateCart, postCart } from '../actions'
import { IReducer, ICartItemUI } from '../interface'
import { removeProductFromCart } from '../services'

interface ICartItemComponent extends ICartItemUI {
  locked?: boolean
  description: string
  icon: string
  userId: string
  stullerAccountObj: {}
  internal: boolean
}

const CartItem = (props: ICartItemComponent) => {
  const { cart, taxes, coupon, isCartLoading } = useSelector((state: IReducer) => state.cartReducer)
  const dispatch = useDispatch()
  const handleDelete = () => {
    const { userId, stullerAccountObj } = props
    const userCart = removeProductFromCart(cart, props)
    props.internal
      ? dispatch(postCart({ taxes, coupon, userCart }))
      : dispatch(updateCart({ customerId: userId, taxes, coupon, userCart, stullerAccountObj }))
  }

  return (
    <TableRow data-cy='cart-element'>
      <TableCell width={60} sx={{ pl: 3 }}>
        <Box component='img' src={props.icon} alt='Product Logo' sx={{ width: 24, display: 'flex' }} />
      </TableCell>
      <TableCell align='left'>{props.description}</TableCell>
      <TableCell data-cy='cart-item-quantity'>x{props.quantity}</TableCell>
      {!props.locked && (
        <TableCell align='right' width={40}>
          <Tooltip title='Remove from bag'>
            <span>
              <IconButton size='small' disabled={isCartLoading} onClick={handleDelete} data-cy='cart-delete'>
                <DeleteOutline fontSize='small' sx={{ fill: '#444' }} />
              </IconButton>
            </span>
          </Tooltip>
        </TableCell>
      )}
    </TableRow>
  )
}

export default CartItem
